export const RTI_DATA_THRESHOLD_MIN = 3;
export const RTI_DATA_THRESHOLD_MAX = 30;
export const RTI_DATA_THRESHOLD_DEFAULT = 3;

export type RtiMinimumDataThresholdModel = {
  data_threshold: number;
};

function clampIntThreshold(n: number): number {
  return Math.min(RTI_DATA_THRESHOLD_MAX, Math.max(RTI_DATA_THRESHOLD_MIN, Math.trunc(n)));
}

export function normalizeRtiMinimumDataThreshold(raw: unknown): RtiMinimumDataThresholdModel {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return { data_threshold: RTI_DATA_THRESHOLD_DEFAULT };
  }
  const rec = raw as Record<string, unknown>;
  const v = rec.data_threshold;
  if (typeof v === 'number' && Number.isFinite(v)) {
    return { data_threshold: clampIntThreshold(v) };
  }
  if (typeof v === 'string') {
    const t = v.trim();
    if (t === '') {
      return { data_threshold: RTI_DATA_THRESHOLD_DEFAULT };
    }
    const n = Number(t);
    if (Number.isFinite(n)) {
      return { data_threshold: clampIntThreshold(n) };
    }
  }
  return { data_threshold: RTI_DATA_THRESHOLD_DEFAULT };
}

export type RtiDataThresholdInputError = 'nonNumeric' | 'outOfRange';

export type RtiDataThresholdParseResult =
  | { ok: true; value: number }
  | { ok: false; error: 'empty' | RtiDataThresholdInputError };

export function parseRtiDataThresholdInput(raw: string): RtiDataThresholdParseResult {
  const trimmed = raw.trim();
  if (trimmed === '') {
    return { ok: false, error: 'empty' };
  }
  const n = Number(trimmed);
  if (!Number.isFinite(n) || !Number.isInteger(n)) {
    return { ok: false, error: 'nonNumeric' };
  }
  if (n < RTI_DATA_THRESHOLD_MIN || n > RTI_DATA_THRESHOLD_MAX) {
    return { ok: false, error: 'outOfRange' };
  }
  return { ok: true, value: n };
}
